import React from 'react';
import { X, Plus, Minus, ShoppingBag, MessageCircle } from 'lucide-react';
import { useCart } from '../context/CartContext';
export function Cart() {
  const {
    isCartOpen,
    toggleCart,
    items,
    removeFromCart,
    updateQuantity,
    cartTotal
  } = useCart();
  const handleCheckout = () => {
    const phoneNumber = '593999999999';
    const lineItems = items.map(item => `  • ${item.quantity}x ${item.name} — $${(item.price * item.quantity).toFixed(2)}`).join('%0A');
    const total = cartTotal.toFixed(2);
    const message = `🥩 *PEDIDO CORTE QUITEÑO*%0A%0AHola! Quiero realizar el siguiente pedido:%0A%0A${lineItems}%0A%0A💰 *Total: $${total}*%0A%0APor favor confirmar disponibilidad y coordinar entrega a domicilio. ¡Gracias!`;
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };
  if (!isCartOpen) return null;
  return <div className="fixed inset-0 z-[60] overflow-hidden" data-id="element-2">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={toggleCart} data-id="element-3" />

      <div className="absolute inset-y-0 right-0 w-full max-w-sm md:max-w-md bg-surface border-l border-ink/10 flex flex-col" data-id="element-4">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-ink/10" data-id="element-5">
          <div className="flex items-center gap-3" data-id="element-6">
            <ShoppingBag className="w-4 h-4 text-fire" data-id="element-7" />
            <h2 className="text-xs uppercase tracking-[0.2em] font-semibold text-ink" data-id="element-8">
              Tu Pedido
            </h2>
          </div>
          <button onClick={toggleCart} className="text-muted hover:text-ink transition-colors" data-id="element-9">
            <X className="w-5 h-5" data-id="element-10" />
          </button>
        </div>

        {/* Items */}
        <div className="flex-1 overflow-y-auto px-6 py-5 space-y-5" data-id="element-11">
          {items.length === 0 ? <div className="flex flex-col items-center justify-center h-full text-muted text-center" data-id="element-12">
              <ShoppingBag className="w-10 h-10 mb-4 opacity-20" data-id="element-13" />
              <p className="text-sm font-light" data-id="element-14">Tu carrito está vacío</p>
              <button onClick={toggleCart} className="mt-5 text-xs uppercase tracking-[0.15em] text-muted hover:text-fire border-b border-muted/30 pb-0.5 transition-colors" data-id="element-15">
                Volver al catálogo
              </button>
            </div> : items.map(item => <div key={item.id} className="flex gap-4" data-id="element-16">
                <div className="w-14 h-14 overflow-hidden flex-shrink-0" data-id="element-17">
                  <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-18" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-19">
                  <div className="flex justify-between items-start mb-1" data-id="element-20">
                    <h3 className="text-sm font-medium text-ink truncate pr-2" data-id="element-21">
                      {item.name}
                    </h3>
                    <button onClick={() => removeFromCart(item.id)} className="text-muted hover:text-fire flex-shrink-0 transition-colors" data-id="element-22">
                      <X className="w-3.5 h-3.5" data-id="element-23" />
                    </button>
                  </div>
                  <p className="text-fire text-sm font-bold mb-2" data-id="element-24">
                    ${item.price.toFixed(2)}
                  </p>
                  <div className="flex items-center gap-2.5" data-id="element-25">
                    <button onClick={() => updateQuantity(item.id, -1)} className="w-6 h-6 border border-ink/15 text-muted hover:border-fire hover:text-fire flex items-center justify-center transition-colors" data-id="element-26">
                      <Minus className="w-3 h-3" data-id="element-27" />
                    </button>
                    <span className="text-ink text-sm w-4 text-center" data-id="element-28">
                      {item.quantity}
                    </span>
                    <button onClick={() => updateQuantity(item.id, 1)} className="w-6 h-6 border border-ink/15 text-muted hover:border-fire hover:text-fire flex items-center justify-center transition-colors" data-id="element-29">
                      <Plus className="w-3 h-3" data-id="element-30" />
                    </button>
                  </div>
                </div>
              </div>)}
        </div>

        {/* Footer */}
        {items.length > 0 && <div className="px-6 py-5 border-t border-ink/10" data-id="element-31">
            <div className="flex justify-between items-baseline mb-5" data-id="element-32">
              <span className="text-xs uppercase tracking-[0.15em] text-muted" data-id="element-33">
                Total Estimado
              </span>
              <span className="text-2xl font-heading font-bold text-ink" data-id="element-34">
                ${cartTotal.toFixed(2)}
              </span>
            </div>
            <button onClick={handleCheckout} className="w-full py-4 bg-fire text-white text-xs uppercase tracking-[0.18em] font-semibold hover:bg-ember transition-colors flex items-center justify-center gap-3" data-id="element-35">
              <MessageCircle className="w-4 h-4" data-id="element-36" />
              Pedir por WhatsApp
            </button>
            <p className="text-[10px] text-center text-muted/50 mt-3 tracking-wide" data-id="element-37">
              Serás redirigido a WhatsApp para coordinar pago y entrega.
            </p>
          </div>}
      </div>
    </div>;
}